import { FormsModule, ReactiveFormsModule } from "@angular/forms";

export const formModules = [
  FormsModule,
  ReactiveFormsModule,
]
